import React, { useEffect, useState } from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags";
interface HistoryDetailProps {
  detail: any;
}

const useStyles = makeStyles((theme: Theme) => createStyles({}));

function HistoryDetail({ detail }: HistoryDetailProps) {
  const classes = useStyles();
  const [historyDetail, setHistoryDetail] = useState<any>(null);

  useEffect(() => {
    setHistoryDetail(detail);
    return () => {
      setHistoryDetail(null);
    };
  }, [detail]);

  if (historyDetail && historyDetail.length > 0) {
    return (
      // <Grid xs={11} item style={{ paddingLeft: "6rem" }}>
      <Grid style={{ paddingTop: 8, width: "100%" }}>
        {historyDetail.map((element: any, index: any) => {
          return (
            <Grid
              container
              style={{ fontWeight: 500, paddingLeft: 32 }}
              key={`history-detail-${index}`}
            >
              <Grid style={{ fontSize: 20, textIndent: -26 }} component={"li"}>
                {/* <span style={{ verticalAlign: "text-bottom" }}>∙</span> */}
                {element.text}
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      // </Grid>
    );
  } else {
    return <div></div>;
  }
}

export default HistoryDetail;
